import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ChildrenOutletContexts, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { NotificationService } from '../../services/notification.service';
import { PIDService } from '../../services/pid.service';
import { ProfileService } from '../../services/profile.service';
import { SearchbarService } from '../../services/searchbar.service';
import { UserService } from '../../services/user.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {

  pids = {
    all: [],
    display: [],
    filtered: [],
    index: {}
  };

  steps = [];
  modal = {
    newPID: false,
    selectTemplate: false,
    agreeToTerms: false
  };
  filter = '';
  profile = null;
  working = false;
  sortableOptions = {};
  ordering = {}

  tuto: any = {
    option: null
  }

  tabindex = 0;
  isPhone = null;
  pid: null;

  @ViewChild('newPID') newPIDModalElem;
  @ViewChild('pidTable') pidTable;
  private eventsSubject: Subject<void> = new Subject<void>();

  emitEventToChild() {
    this.eventsSubject.next()
  }

  constructor(private _user: UserService, private _pidService: PIDService, private _notification: NotificationService,
    public translate: TranslateService, private _profile: ProfileService, private _searchService: SearchbarService,
    private _route: ActivatedRoute, private router: Router) {

    console.log("home constructor", this.router);

    this.steps.push({ name: ['Proprieties'], ref: [''] })
    this.sortableOptions = {

      onUpdate: (event: any) => {
        let ordering = [];
        var c = 0;
        for (let p of this.pids.display) {
          ordering.push({ _id: p._id, c: c });
          c += 1;
        }

        this._pidService.changeSorting(ordering).subscribe(data => {

        }, err => {
          this._notification.errorServer(err);
        });

      }
    };
  }

  agreeToTerms() {
    this._user.agreeToTerms()
      .subscribe(success => {
        this._notification.success('MESSAGE.SUCCESS', ' ');
        this.modal.agreeToTerms = false;
        this.modal.selectTemplate = (this.pids.all.length == 0);
      }, err => {
        this._notification.errorServer(err);
      })
  }

  ngOnInit() {
    console.log("home ngoninit", this._user);
    var SH_CUID = this._user.me()['_id'];
    var firstname = this._user.me()['firstname'];
    /*
    window['streethawk'].ready(function () {

      let APP_KEY = 'Bart_Testd2acc6a';
      let EVENT_KEY = 'evtqPmIq7HkMxml8av845asdtbowPgiHv';

      window['streethawk'].register(APP_KEY, EVENT_KEY, SH_CUID).then(function () {
        // Send String Tag
        let key = "sh_first_name";
        let value = firstname;
        window['streethawk'].tag.string(key, value);
      });
    });
    */

    this.isPhone = window.matchMedia('(max-width: 767px)').matches;

    this._profile.me().subscribe(
      (me: any) => {
        this.profile = me;
        if (me.company) {
          this.tabindex = 1;
        }
        this._route.data.subscribe(
          data => {
            let pids = data['pids'];
            this.updateTable(pids);

            this._pidService.getFromOwnerWithStats(this._user.me()['_id']).subscribe((data: any) => {
              this.updateStats(data);
            });

            console.log("filtering done", this.pids);
            if (this.isPhone) {
              this.tabindex = 0;
            }
          },
          err => this._notification.errorServer(err)
        );
      },
      err => this._notification.errorServer(err)
    );
  }

  updateStats(data){
    data.forEach(x => {
      this.pids.index[x._id].late = x.late;
      this.pids.index[x._id].children = x.children;
      this.pids.index[x._id].warning = x.warning;
    });
  }

  canAddPID() {
    return (this.profile && this.profile.PIDLimit > _.filter(this.pids.all, (p => {
      return !p.template
    })).length);
  }

  filterOnOff() {
    if (this.tabindex) {
      this.tabindex = 0;
    } else {
      this.tabindex = 1;
    }
  }

  filterPID(filter) {
    //console.log("filter PID", filter);
    this._searchService.filter(this.pids, filter, ['img', '_id', 'transferTo']); // 'PIDOwner', 
    this.pids.filtered = [...this.pids.display];
    //console.log("filter PID done, emit", this.pids.filtered);
    this.eventsSubject.next();
  }

  updateTable(pids) {
    //console.log("update table");
    this.pids = {
      display: _.filter(pids, pid => {
        // return !pid.parentPID;
        //console.log("check", pid.name, pid.parentPID, pid.sharedWith, pid.sharedWith.map(x=>x._id), (pid.sharedWith && pid.sharedWith.filter(x=>(x._id || x)== this._user.me()['_id']).length));
        return !pid.parentPID || (pid.sharedWith && pid.sharedWith.filter(x=>(x._id || x)== this._user.me()['_id']).length);
      }),

      filtered: _.filter(pids, pid => {
        // return !pid.parentPID;
        return !pid.parentPID || (pid.sharedWith && pid.sharedWith.filter(x=>(x._id||x)== this._user.me()['_id']).length);
      }),
      all: pids,
      index: pids.reduce(function (map, obj) {
        map[obj._id] = obj;
        return map;
      }, {})
    };
    //console.log(this.pids);
    this.modal.selectTemplate = (pids.length == 0) && !this.modal.agreeToTerms;
  }

  SwitchTab(index){
    //console.log("switch tab", index);
    if (index == 0){
      this.updateTable(this.pids['all']);
    }

    this.tabindex = index;
  }

  reload = () => {
    //console.log("home reload", this, this._user);
    this._pidService.getFromOwner(this._user.me()['_id']).subscribe((data: any) => {
      this.updateTable(data);
      
      this._pidService.getFromOwnerWithStats(this._user.me()['_id']).subscribe((data: any) => {
        this.updateStats(data);
        this.pidTable && this.pidTable.doUpdateFilter();
        this.pidTable && this.pidTable.updateAllStatusCount();
      });
    },
      err => this._notification.errorServer(err));

  }

  refilter() {
    console.log("home refilter");
  }

  setOption(value: string) {
    this.tuto.option = value;
  }

  addPID() {
    this.canAddPID() ? this.modal.newPID = true : this._notification.info('MESSAGE.PID_LIMIT_REACHED');
  }

  pidAdded = () => {
    this.pidTable && this.pidTable.doUpdateFilter('all');
  }

  createPID = () => {
    this.newPIDModalElem.addPID(this.pidAdded);
  }

}
